export function formatDuration(seconds, { padMinutes = false } = {}) {
  if (!Number.isFinite(seconds) || seconds < 0) {
    return padMinutes ? '00:00' : '0:00';
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  const mm = padMinutes
    ? minutes.toString().padStart(2, '0')
    : String(minutes);
  const ss = remainingSeconds.toString().padStart(2, '0');
  return `${mm}:${ss}`;
}

export function formatTime(seconds) {
  return formatDuration(seconds, { padMinutes: true });
}

export function formatAudioTime(seconds) {
  return formatDuration(seconds, { padMinutes: false });
}
